export const config = {
  resumeLink:
    "https://drive.google.com/file/d/1SC6mw-Ok1qjYdBkOeGaGWxkEONLk2o8E/view?usp=sharing",
};
